<ng-container *ngIf="cargaTotal">
  <h1 mat-dialog-title>{{'DESCARGAR_ENCUESTA.MODAL.TITLE' | translate}}</h1>
  <div mat-dialog-content>
    <ng-container [ngSwitch]="hasNorma">
      <h3 *ngSwitchCase="false">{{'DESCARGAR_ENCUESTA.MODAL.SUBTITLE' | translate}}</h3>
      <h3 *ngSwitchCase="true">{{'DESCARGAR_ENCUESTA.MODAL.TIPOENCUESTA' | translate}}</h3>
    </ng-container>
    <mat-select class="selectLangs" placeholder="{{'DESCARGAR_ENCUESTA.MODAL.PLACEHOLDER' | translate}}">
      <ng-container [ngSwitch]="hasNorma">
        <ng-container *ngSwitchCase="false">
          <mat-option *ngFor="let lang of langs" [value]="lang.id" (click)="selLangId(lang)">
            {{lang.nombre}}
          </mat-option>
        </ng-container>
        <ng-container *ngSwitchCase="true">
          <mat-option *ngFor="let nom of selectNorma" [value]="nom.id" (click)="selectNom35(nom)">
              {{nom.nombre | translate}}
          </mat-option>
        </ng-container>
      </ng-container>
    </mat-select>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick();">{{'DESCARGAR_ENCUESTA.MODAL.BTNCLOSE' | translate}}</button>
    <button mat-raised-button *ngIf="!hasNorma" (click)="downLoad();" [disabled]="btnLocked">{{'DESCARGAR_ENCUESTA.MODAL.BTNSELECT' | translate}}</button>
    <button mat-raised-button *ngIf="hasNorma" (click)="downLoad35();" [disabled]="btnLocked">{{'DESCARGAR_ENCUESTA.MODAL.BTNSELECT' | translate}}</button>
  </div>
</ng-container>
